export const underlyingYield: Record<string, number> = {
  '0x2b2C81e08f1Af8835a78Bb2A90AE924ACE0eA4bE': 7.2,
};
